// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__CeFv9","icon-wrapper":"style_icon-wrapper__8VqeA","alert-title":"style_alert-title__8hxHY"};